export default __webpack_public_path__ + "0bd2c115c759d90c8a48446d7dd612b7.svg";